export interface CurrencyDescription {
  symbol: string;
  subunitToUnit: number;
  precision: number;
  order: number;
  displayCode: string;
}

export const CURRENCY_DESCRIPTION = Object.freeze<Record<string, CurrencyDescription>>({
  USD: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
    order: 0,
    displayCode: '',
  },
  CAD: {
    symbol: 'C$',
    subunitToUnit: 100,
    precision: 2,
    order: 1,
    displayCode: 'CAD',
  },
  AUD: {
    symbol: 'A$',
    subunitToUnit: 100,
    precision: 2,
    order: 4,
    displayCode: 'AUD',
  },
  GBP: {
    symbol: '£',
    subunitToUnit: 100,
    precision: 2,
    order: 3,
    displayCode: 'GBP',
  },
  EUR: {
    symbol: '€',
    subunitToUnit: 100,
    precision: 2,
    order: 2,
    displayCode: 'EUR',
  },
  JPY: {
    symbol: '¥',
    subunitToUnit: 1,
    precision: 0,
    order: 5,
    displayCode: 'JPY',
  },
  NZD: {
    symbol: 'NZ$',
    subunitToUnit: 100,
    precision: 2,
    order: 6,
    displayCode: 'NZD',
  },
  MXN: {
    symbol: 'MEX$',
    subunitToUnit: 100,
    precision: 2,
    order: 7,
    displayCode: 'MXN',
  },
  BRL: {
    symbol: 'R$',
    subunitToUnit: 100,
    precision: 2,
    order: 9,
    displayCode: 'BRL',
  },
  DKK: {
    symbol: 'kr.',
    subunitToUnit: 100,
    precision: 2,
    order: 10,
    displayCode: 'DKK',
  },
  HKD: {
    symbol: 'HK$',
    subunitToUnit: 100,
    precision: 2,
    order: 11,
    displayCode: 'HKD',
  },
  NOK: {
    symbol: 'kr',
    subunitToUnit: 100,
    precision: 2,
    order: 12,
    displayCode: 'NOK',
  },
  PHP: {
    symbol: '₱',
    subunitToUnit: 100,
    precision: 2,
    order: 13,
    displayCode: 'PHP',
  },
  PLN: {
    symbol: 'zł',
    subunitToUnit: 100,
    precision: 2,
    order: 14,
    displayCode: 'PLN',
  },
  SEK: {
    symbol: 'kr',
    subunitToUnit: 100,
    precision: 2,
    order: 16,
    displayCode: 'SEK',
  },
  CHF: {
    symbol: 'CHF',
    subunitToUnit: 100,
    precision: 2,
    order: 17,
    displayCode: 'CHF',
  },
});

export const CURRENCY_EXPANSION_DESCRIPTION = Object.freeze<Record<string, CurrencyDescription>>({
  CZK: {
    symbol: 'CZK',
    subunitToUnit: 100,
    precision: 2,
    order: 18,
    displayCode: 'CZK',
  },
  // The forint has no minor unit, so an amountCents of 5000 is 5,000 Ft rather
  // than 50.00 Ft. This must stay in sync with the backend, where the money gem
  // models HUF with subunit_to_unit = 1 and serializes amount_cents as whole
  // forints -- declaring it as 100/2 here renders every HUF amount 100x too small.
  HUF: {
    symbol: 'HUF',
    subunitToUnit: 1,
    precision: 0,
    order: 19,
    displayCode: 'HUF',
  },
});
